import React from 'react';
// import PropTypes from 'prop-types';
import { getOne, deleteOne } from 'api/environmentProtectionWorkApi';
import Message from 'rc-message';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import Permissions from 'react-redux-permissions';

// import * as _ from 'lodash';
import Clearfix from 'components/elements/clearfix';
import DisplayField from 'components/elements/display-field';
import Confirm from 'components/elements/confirm-element';
import slug from 'constants/slug';
import { COLOR, DATETIME_FORMAT, DATE_FORMAT } from 'config';
import AttachmentContainer from 'containers/AttachmentContainer';
import {
  getList as getFacAttachList,
  deleteOne as deleteAttach,
  create as createFacAttach,
} from 'api/environmentProtectionWorkAttachmentApi';
import { getLookupTypeEnvironmentProtectionWorkAttachment } from 'api/lookuplistitemApi';

import PageLockHOC from 'hoc/pageLock';
import _ from 'lodash';
import { IS_ENTERPRISE } from 'config';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

@PageLockHOC(['environmentProtectionWork.view'])
@connect(
  (state) => ({
    menuSelected_2: state.menu.menuSelected_2,
    focusFacility: state.menu.focusFacility,
  }),
  {}
)
class EnvironmentProtectionWorkView extends React.Component {
  state = {
    _idObject: '',
    isLoaded: false,
    facility: {},
    facilityId: '',
    initialValue: null,
  };

  getInitialValue = (keyPath, defaultValue = '', type = 'string') => {
    // return _.result(this.state.initialValue, keyPath, defaultValue);

    const value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) {
      return '';
    }
    switch (type) {
      case 'date':
      case 'date_1':
        return moment(value).format(
          type === 'date_1' ? DATETIME_FORMAT : DATE_FORMAT
        );
      case 'dates':
        return `${moment(value[0]).format(DATE_FORMAT)} - ${moment(
          value[1]
        ).format(DATE_FORMAT)}`;
      default:
        return value;
    }
  };

  getInitialDateValue = (keyPath, isDate, defaultValue = '') => {
    let value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) return '';
    if (isDate) return moment(value).format(DATE_FORMAT);
    return moment(value).format(DATETIME_FORMAT);
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');
    if (_id) {
      const res = await getOne(_id);
      // console.log(res);
      if (res.success && res.data) {
        this.setState({
          _idObject: _id,
          facility: res.data.facility,
          facilityId: res.data.facility._id,
          isLoaded: true,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.FACILITY_PERMIT.LIST);
    }
  }

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      const FacilityNameFull = this.getInitialValue(
        'facility.FacilityNameFull'
      );
      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {`Bạn có muốn xóa báo cáo công tác bảo vệ môi trường của tên cơ sở/dự án: `}{' '}
            <b> {FacilityNameFull}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              if (this.props.menuSelected_2) {
                this.props.history.push(
                  `${slug.CO_SO.VIEW_WITH_ID}${this.props.focusFacility}`
                );
              } else {
                this.props.history.push(slug.ENVIRONMENT_PROTECTION_WORK.LIST);
              }
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  async componentWillMount() {
    await this.checkValidate();
  }

  getRenderChemistries = () => {
    const data = _.result(this.state.initialValue, 'Chemistries', []);
    return _.map(data, (obj, inx) => {
      let value = _.get(obj, 'chemistry.Name', '')
        ? _.get(obj, 'chemistry.Name', '')
        : _.get(obj, 'chemistryType.Name', '');

      const moreInfo = _.get(obj, 'chemistryType.moreInfo', []);
      const nodeProperty = _.map(moreInfo, (item, index) => {
        const dataMoreInfo = obj.moreInfo;
        return (
          <React.Fragment key={index}>
            <Clearfix height={8} />
            <DisplayField
              size={14}
              key={index}
              label={item.name}
              value={dataMoreInfo ? dataMoreInfo[item.key] : ''}
            />
          </React.Fragment>
        );
      });
      return (
        <React.Fragment key={inx}>
          <Clearfix height={8} />
          <DisplayField
            size={14}
            isRequiredField
            label='Loại chất thải'
            value={value}
          />

          {nodeProperty}
        </React.Fragment>
      );
    });
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Báo cáo công tác bảo vệ môi trường
        </h4>
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            <Icon
              onClick={() => {
                this.props.history.push(slug.ENVIRONMENT_PROTECTION_WORK.LIST);
              }}
              style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
              icon={IconNames.CIRCLE_ARROW_LEFT}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.SUCCESS}
            />
            <React.Fragment>
              <Permissions allowed={[`environmentProtectionWork.write`]}>
                <React.Fragment>
                  <Clearfix width={8} />
                  <Link
                    to={
                      slug.ENVIRONMENT_PROTECTION_WORK.EDIT_WITH_ID +
                      this.state._idObject
                    }
                  >
                    <Icon
                      style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                      icon={IconNames.MANUALLY_ENTERED_DATA}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.PRIMARY}
                    />
                  </Link>
                </React.Fragment>
              </Permissions>
              <Permissions allowed={[`environmentProtectionWork.delete`]}>
                <React.Fragment>
                  <Clearfix width={8} />
                  <Icon
                    style={{ cursor: 'pointer' }}
                    icon={IconNames.BAN_CIRCLE}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.DANGER}
                    onClick={this.handelDelete}
                  />
                </React.Fragment>
              </Permissions>
            </React.Fragment>
          </div>
        </HeaderContainer>
        <Clearfix height={16} />
        <DisplayField
          size={14}
          isRequiredField
          label='Tên cơ sở/dự án'
          value={this.getInitialValue('facility.FacilityNameFull')}
        />
        <Clearfix height={8} />

        {!IS_ENTERPRISE && (
          <React.Fragment>
            <DisplayField
              size={14}
              label='Tên doanh nghiệp'
              value={this.getInitialValue('facility.organizationName')}
            />
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <DisplayField
          size={14}
          label='Địa chỉ'
          value={this.getInitialValue('facility.Address1')}
        />
        <Clearfix height={8} />
        <DisplayField
          size={14}
          label='Năm báo cáo'
          value={this.getInitialValue('YearReport')}
        />
        <Clearfix height={8} />
        <DisplayField
          size={14}
          label='Ngày nộp'
          value={this.getInitialValue('DateFiling', '', 'date')}
        />
        <Clearfix height={8} />
        <Row>
          <Col xs={5}>
            <b style={{ fontSize: 14 }}>Hồ sơ chất thải</b>
          </Col>
        </Row>
        {this.getRenderChemistries()}
        <Clearfix height={8} />
        <Row>
          <Col xs={5}>
            <b style={{ fontSize: 14 }}>Chứng từ xử lý chất thải</b>
          </Col>
        </Row>
        <Clearfix height={8} />
        <DisplayField
          size={14}
          label='Chứng từ nguồn thải'
          value={this.getInitialValue('LicenseWasteSources')}
        />
        <Clearfix height={8} />
        <DisplayField
          size={14}
          label='Chứng từ vận chuyển'
          value={this.getInitialValue('LicenseTransport')}
        />
        <Clearfix height={8} />
        <DisplayField
          size={14}
          label='Chứng từ xử lý chất thải'
          value={this.getInitialValue('LicenseWasteTreatment')}
        />
        <Clearfix height={8} />
        <Row>
          <Col xs={5}>
            <b style={{ fontSize: 14 }}>Kết quả khắc phục theo yêu cầu</b>
          </Col>
        </Row>
        <Clearfix height={8} />
        <DisplayField
          size={14}
          label='Kết quả khắc phục'
          value={this.getInitialValue('ResultFix')}
        />
        <Clearfix height={8} />
        <DisplayField
          size={14}
          label='Thêm vào'
          value={
            this.getInitialDateValue('AddedOn') +
            ' bởi ' +
            this.getInitialValue('AddedBy')
          }
        />
        <Clearfix height={8} />
        <DisplayField
          size={14}
          label='Cập nhật lần cuối'
          value={`${this.getInitialValue('UpdatedOn', '', 'date_1')}${
            this.getInitialValue('UpdatedBy', '')
              ? ` bởi ${this.getInitialValue('UpdatedBy', '')}`
              : ''
          }`}
        />
        <Clearfix height={8} />
        {this.state.isLoaded && (
          <AttachmentContainer
            hideButtonAction={false}
            facility={this.state.initialValue}
            getListFunc={(query) => {
              return getFacAttachList({
                ...query,
                environmentProtectionWork: this.state._idObject,
              });
            }}
            createOne={(values) => {
              values.environmentProtectionWork = this.state._idObject;
              return createFacAttach(_.pickBy(values, _.identity));
            }}
            deleteOne={deleteAttach}
            getAttachmentTypeList={
              getLookupTypeEnvironmentProtectionWorkAttachment
            }
            moduleName='environmentProtectionWork'
          />
        )}
      </div>
    );
  }
}

export default withRouter(EnvironmentProtectionWorkView);



// WEBPACK FOOTER //
// ./src/containers/environment-protection-work/environment-protection-work-View/index.js